import React, { Component } from 'react';
import CardPage from '../../../commonModules/layouts/CardPage';
import SpendingList from './SpendingList';
import { isEmpty } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchSpendings, updateSpending } from '../../../../../../jsx/actions/spendingAction';
import Spin from '../../../commonModules/interface/Spin';
import { Card, Box, AppBar, Tabs, Tab } from '@material-ui/core';


class Spendings extends Component {
    state = { 
        headerMenu: "ALL"
    }
    componentDidMount() {
        if(isEmpty(this.props.SPENDINGS.ALL)){
            this.props.fetchSpendings()
        }
    }
    onChangeTab = async (e, headerMenu) => {
       
        this.setState({ headerMenu })
    }
    render() {
        const { headerMenu } = this.state;
        const { STATE } = this.props;
        console.log('==== SPENDINGS ====== PROPS ========');
        console.log(this.props);
        console.log('====================================');
        return (
            <CardPage title="Listes des dépenses">
                { STATE.fetching && 
                    <div className="text-center">
                        <Spin noOverlay /> 
                    </div>
                }
                <Card>
                    <AppBar position="static">
                        <Tabs
                            value={headerMenu}
                            onChange={this.onChangeTab}
                            indicatorColor="secondary"
                            // textColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab value="ALL" label="Toutes les dépenses" />
                            <Tab value="WaitingPayment" label="En attente de paiement" />
                            <Tab value="Payed" label="Paiement" />
                        </Tabs>
                    </AppBar>
                </Card>
                <Box p={2}>
                { !STATE.fetching && <SpendingList {...this.props} {...this.state} /> }
                </Box>
            </CardPage>
            
        );
    }
}

function mapStateToProps(state){
    return {
        SPENDINGS: state.spendings,
        STATE: state.inventory.requestState.spendings,

    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        fetchSpendings,
        updateSpending
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Spendings);